import './Footer.scss';

import * as React from 'react';

interface IFooterProps {

}

class Footer extends React.PureComponent<IFooterProps, any> {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
    }

    componentWillReceiveProps(nextProps: any) {
    }

    componentDidUpdate(prevProps: any) {

    }

    componentWillUpdate(nextProps: any) {
    }

    componentWillUnmount() {
    }

    render() {

        return (
            <div className="footer py-2 px-4">
                <div className="d-flex justify-content-center">
                    <span className="footer-text">Copyright&nbsp;&copy;&nbsp;{new Date().getFullYear().toString()} ANZ Breast Cancer Trials Group Ltd | ABN 64 051 369 496</span>
                </div>
            </div>
        );
    }
}

export default Footer;